export const units = {
  seminalFluidAnalysis: {
    appearance: '',
    liquefactionTime: 'mins',
    viscosity: '',
    volume: 'ml',
    ph: '',
    agglutination: '',
    roundCellCount: '',
  },
  spermAnalysis: {
    spermCount: 'M/ml',
    totalCount: 'M/Ejaculate',
    motility: '%',
    progression: '%',
    nonProgression: '%',
    immotile: '%',
    viability: '%',
    morphologyNormal: '%',
    morphologyAbnormal: '%',
  },

  qualityAnalysis: {
    head: {
      tapered: '%',
      pyriform: '%',
      amorphous: '%',
      roundHead: '%',
      macrocephalic: '%',
      microcephalic: '%',
      doubleHead: '%',
      cytoplasmicDroplet: '%',
      vacuolatedSpermHead: '%',
    },
    midpiece: {
      bentNeck: '%',
      asymmetrical: '%',
      thin: '%',
      thick: '%',
    },
    tail: {
      coiledTail: '%',
      shortTail: '%',
      brokenTail: '%',
    },
  },
  dnaFregmentationIndex: '%',
};
